import LC from "@/repositories/lisacomunica/lc";

export default {
  // Email
  index(queryString) {
    // ordinamento alfabetico per titolo fatto da LisaComunica
    let resource = `/email/all?sort=title,asc`;
    return queryString
      ? LC.get(`${resource}&${queryString}`)
      : LC.get(`${resource}`);
  },
  show(id) {
    let resource = `/email`;
    return LC.get(`${resource}/${id}`);
  },
  store(payload) {
    let resource = `/email/new`;
    // save the item
    return LC.post(`${resource}`, payload);
  },
  update(id, payload) {
    let resource = `/email`;
    // update the item
    return LC.put(`${resource}/${id}`, payload);
  },
  destroy(id) {
    let resource = `/email`;
    // delete the item
    return LC.delete(`${resource}/${id}`);
  },
  // EMAIL (presets)
  preset_index(queryString) {
    let resource = `/email/preset/all`;
    return queryString
      ? LC.get(`${resource}?${queryString}`)
      : LC.get(`${resource}`);
  },
  preset_show(id) {
    let resource = `/email/preset`;
    return LC.get(`${resource}/${id}`);
  },
  start(payload) {
    let resource = "/email/start";
    // save the procedure_id
    return LC.post(`${resource}`, payload);
  },
  send_email(payload) {
    let resource = "/email/send"; // #1126 TODO check the real endpoint
    // send email with template_id (payload)
    return LC.post(`${resource}`, payload);
  },
};
